import { z } from 'zod/v4';

export const TechInsightCategories = [
  'user activity',
  'vendor',
  'compliance',
  'tracing',
  'assets',
  'uncategorised',
] as const;

export const TechInsightItemSchema = z.object({
  key: z.string(),
  value: z.number(),
  category: z.enum(TechInsightCategories),
});

export type TechInsightItem = z.infer<typeof TechInsightItemSchema>;

export const CompanyTechInsightsResponseSchema = z.array(TechInsightItemSchema);

export type CompanyTechInsightsResponse = z.infer<
  typeof CompanyTechInsightsResponseSchema
>;
